// extracted by mini-css-extract-plugin
export var border = "_q-7";
export var brand = "_q-s";
export var button = "_q-k";
export var center = "_q-9";
export var centered = "_q-5";
export var closeButton = "_q-b";
export var disabledWrapper = "_q-l";
export var error = "_q-o";
export var extraLarge = "_q-4";
export var extraSmall = "_q-1";
export var fill = "_q-h";
export var footer = "_q-g";
export var footerAction = "_q-i";
export var footerButtons = "_q-j";
export var header = "_q-6";
export var headerWithClose = "_q-c";
export var icon = "_q-n";
export var info = "_q-r";
export var inline = "_q-8";
export var large = "_q-3";
export var main = "_q-d";
export var modal = "_q-0";
export var neutral = "_q-t";
export var noPadding = "_q-f";
export var none = "_q-u";
export var scrollable = "_q-e";
export var small = "_q-2";
export var success = "_q-q";
export var tight = "_q-m";
export var titleIcon = "_q-a";
export var warn = "_q-p";